import { useTranslation } from "react-i18next";
import { CommonDialog } from "../../home/CommonDialog";

interface ErrorDialogProps {
  open: boolean;
  message: string;
  onAccept?: () => void;
}

export const ErrorDialog = (props: ErrorDialogProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <CommonDialog
      open={props.open}
      title={t("error.error")}
      acceptButtonName={t("common.backButton")}
      onAccept={props.onAccept}
    >
      <div>{props.message}</div>
    </CommonDialog>
  );
};
